<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left is-padding-right">
        <span v-if="c.created_on">Contact créé le <b>{{c.created_on|prettyDate}}</b></span>
        <span v-if="c.created_on && c.seller_name"> - </span>
        <span v-if="c.seller_name">Utilisateur référent : <b>{{c.seller_name}}</b></span>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-6 is-paddingless is-border-right">
        <div class="column is-12 columns is-gapless is-multiline is-vcentered">
          <div class="column is-12 is-margin-bottom-small">
            <span v-if="isHuman" class="title is-4"><b>{{c.title === 'mrs' ? 'Mme' : 'M.'}} {{c.last_name}} {{c.first_name}}</b></span>
            <span v-else class="title is-4"><b>{{c.corporation_name}}</b></span>
          </div>
          <div v-if="!isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">Siret</span>
          </div>
          <div v-if="!isHuman" class="column is-6">
            <span class="title is-6" v-if="c.corporation_siret">{{c.corporation_siret}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">Civilité</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6">{{c.title === 'mrs' ? 'Mme' : 'M.'}}</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">Date de naissance / Age</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6" v-if="c.birthday || c.age">
              {{c.birthday | prettyDate}}
              <span v-if="c.birthplace"> à {{c.birthplace}}</span>
              <span v-if="c.birthday && c.age"> - </span>
              <i v-if="c.age">{{c.age}} ans</i>
            </span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">Nationalité</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6" v-if="c.nationality">{{c.nationality}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">Situation Familiale</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6" v-if="c.family_situation">{{c.family_situation|familySituationLabel}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">{{c.family_situation === 'married' ? 'Statut Matrimonial' : 'Régime de PACS'}}</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6"
                  v-if="c.matrimonial_status && c.family_situation && ['married', 'pacs'].includes(c.family_situation)">
              {{c.matrimonial_status | matrimonalStatusLabel}}
            </span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">Enfants</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6" v-if="c.children">{{c.children}}</span>
            <span class="title is-6" v-else>-</span>
          </div>

          <div class="column is-12 is-margin-top-small">
            <span class="title is-6"><b>Adresse et contact :</b></span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Téléphone</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.phone">{{c.phone}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Email</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.email">{{c.email}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Adresse</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.address">{{c.address.line1}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Code postal</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.address.zip_code">{{c.address.zip_code}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Ville</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.address.city">
              {{c.address.city}} <i>({{c.address.country}})</i>
            </span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <router-link :to="{name: 'ContactEdit', params: {id: c.pk}}" class="is-underline is-size-7">
              <span><i>Modifier fiche</i></span>
            </router-link>
          </div>
        </div>
        <div class="column is-12 columns is-gapless is-multiline is-vcentered is-border-top">
          <div class="column is-12 is-margin-bottom-small">
            <span class="title is-4"><b>Situation professionelle et fiscale</b></span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="is-size-6 has-text-grey">CSP</span>
          </div>
          <div v-if="isHuman" class="column is-6">
            <span class="title is-6" v-if="c.csp">{{c.csp|contactCspLabel}}</span>
            <span class="title is-6" v-else>-</span>
          </div>

          <div v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)" class="column is-6">
            <span class="is-size-6 has-text-grey">Profession</span>
          </div>
          <div v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)" class="column is-6">
            <span class="title is-6" v-if="c.profession">{{c.profession}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)" class="column is-6">
            <span class="is-size-6 has-text-grey">Société</span>
          </div>
          <div v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)" class="column is-6">
            <span class="title is-6" v-if="c.contact_company">{{c.contact_company}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6 is-margin-top">
            <span class="is-size-6 has-text-grey">Revenu annuel (avant abattements)</span>
          </div>
          <div class="column is-6 is-margin-top">
            <span class="title is-6" v-if="c.income">{{c.income | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Revenus fonciers</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.land_income">{{c.land_income | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Montant impots sur le revenu</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.tax_income">{{c.tax_income | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Parts fiscales</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.fiscal_share">{{c.fiscal_share|prettyPrice}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6 is-margin-top">
            <span class="is-size-6 has-text-grey">Propriétaire</span>
          </div>
          <div class="column is-6 is-margin-top-small">
            <span class="title is-6">
              <span v-if="c.is_owner">Oui</span>
              <span v-else-if="c.is_owner === null">-</span>
              <span v-else>Non</span></span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Endettement</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.debt">{{c.debt | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Investissement locatif</span>
          </div>
          <div class="column is-6">
            <span class="title is-6">
              <span v-if="c.invest">Oui</span>
              <span v-else-if="c.invest === null">-</span>
              <span v-else>Non</span>
            </span>
          </div>
          <div class="column is-12 is-paddingless columns is-multiline" v-if="c.invest">
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">Nature de l'investissement</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="title is-6" v-if="c.invest_type">{{c.invest_type}}</span>
              <span class="title is-6" v-else>-</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">Valeur de l'achat</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="title is-6" v-if="c.invest_value">{{c.invest_value | prettyPrice}} {{$currency}}</span>
              <span class="title is-6" v-else>-</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">Date de l'achat</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="title is-6" v-if="c.invest_date">{{c.invest_date|date}}</span>
              <span class="title is-6" v-else>-</span>
            </div>
          </div>
          <div class="column is-12 is-paddingless columns" v-for="(loan, i) in c.loans" :key="i">
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">{{loan.loan_type}}</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="title is-6">
                <span v-if="loan.loan_rate">{{loan.monthly_cost | prettyPrice}} {{$currency}}</span>
                <span v-if="loan.monthly_cost && loan.ending_date"> - </span>
                <span v-if="loan.ending_date">Fin : {{loan.ending_date|date}}</span>
                <span v-if="loan.ending_date && loan.loan_rate"> - </span>
                <span v-if="loan.loan_rate">Tx : {{loan.loan_rate | prettyPrice}} %</span>
              </span>
            </div>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Capital disponible</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.available_capital">{{c.available_capital | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Charges fixes mensuelle</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.monthly_outcome">{{c.monthly_outcome | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Effort d'épargne (mensuel)</span>
          </div>
          <div class="column is-6">
            <span class="title is-6" v-if="c.monthly_saving">{{c.monthly_saving | prettyPrice}} {{$currency}}</span>
            <span class="title is-6" v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <router-link :to="{name: 'ContactEdit', params: {id: c.pk}}" class="is-underline is-size-7">
              <span><i>Modifier fiche</i></span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="column is-6 is-paddingless">
        <div v-if="spouse"
             class="column is-12 columns is-gapless is-multiline is-vcentered has-bg-black has-text-white">
          <div class="column is-12 is-margin-bottom-small">
            <router-link :to="{name: 'ContactVue', params: {id: spouse.pk}}" class="title is-4 has-text-white">
              <b>{{spouse.title === 'mrs' ? 'Mme' : 'M.'}} {{spouse.last_name}} {{spouse.first_name}}</b>
            </router-link>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Civilité</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white">{{spouse.title === 'mrs' ? 'Mme' : 'M.'}}</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Date de naissance / Age</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.birthday || spouse.age">
              {{spouse.birthday | prettyDate}}
              <span v-if="spouse.birthplace"> à {{spouse.birthplace}}</span>
              <span v-if="spouse.birthday && spouse.age"> - </span>
              <i v-if="spouse.age">{{spouse.age}} ans</i>
            </span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Nationalité</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.nationality">{{spouse.nationality}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">CSP</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.csp">{{spouse.csp|contactCspLabel}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Profession</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.profession">{{spouse.profession}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Société</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.contact_company">{{spouse.contact_company}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>

          <div class="column is-12 is-margin-top-small">
            <span class="title is-6 has-text-white"><b>Adresse et contact :</b></span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Téléphone</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.phone">{{spouse.phone}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Email</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.email">{{spouse.email}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Adresse</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.address">{{spouse.address.line1}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Code postal</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.address.zip_code">{{spouse.address.zip_code}}</span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Ville</span>
          </div>
          <div class="column is-6">
            <span class="title is-6 has-text-white" v-if="spouse.address.city">
              {{spouse.address.city}} <i>({{spouse.address.country}})</i>
            </span>
            <span class="title is-6 has-text-white" v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <router-link :to="{name: 'ContactEdit', params: {id: spouse.pk}}"
                         class="is-underline has-text-white is-size-7">
              <span><i>Modifier fiche</i></span>
            </router-link>
          </div>
        </div>
        <div class="column is-12 columns is-gapless is-paddingless is-multiline">
          <div class="colmun is-12 columns is-gapless w100 has-bg-light is-padding-top is-padding-left is-padding-bottom-small is-multiline"
               v-if="!spouse && c.nature !== 'corporation'">
            <div class="column is-narrow is-padding-right-xsmall">
              <button @click="openNewContactQuickView"
                      class="button is-small is-white is-border is-rounded is-padding-right-large is-padding-left-large">
                <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-user-crown"></i></span>
                <span class="is-transform-none">Créer fiche conjoint(e)</span>
              </button>
            </div>
            <div class="column is-narrow">
              <button @click="openContactSelectionQuickView"
                      class="button is-small is-white is-border is-rounded is-padding-right-large is-padding-left-large">
                <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-users-crown"></i></span>
                <span class="is-transform-none">Sélectionner fiche conjoint(e)</span>
              </button>
            </div>
          </div>
          <div class="column is-padding-top is-padding-right is-padding-left is-12">
            <span class="title is-4"><b>Commentaire(s)</b></span>
          </div>
        </div>
        <div class="is-overflow-auto" style="max-height: 460px;">
          <div class="column is-12 columns is-gapless is-paddingless is-multiline">
            <div v-if="c.comment == undefined || c.comment.length == 0"
                 class="column is-12 is-padding is-margin-top-small has-bg-light is-border-top">
              <div class="columns is-vcentered is-gapless is-pulled-right">
                <div class="column is-narrow">
                  <button @click="openNewComment(false)"
                          class="button is-primary is-xsmall is-radius-large">
                    <span class="icon is-small"><i class="fas fa-marker"></i></span>
                    <span>Ajouter commentaire</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="c.comment && c.comment.length"
                 class="column is-padding is-12 is-margin-top-small has-bg-light is-border-top">
              <div class="content has-text-text is-size-6" v-if="c.comment && c.comment.length"
                   v-html="c.comment"></div>
              <div class="title is-6" v-else>-</div>
              <div class="columns is-vcentered is-gapless is-pulled-right">
                <div class="column is-narrow">
                  <button @click="openNewComment(true)"
                          class="button is-xsmall is-grey-light has-text-white">
                    <span class="icon is-small"><i class="fas fa-marker"></i></span>
                    <span>{{c.comment && c.comment.length ? 'Modifier / Compléter' : 'Ajouter'}}</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="column is-padding is-12 vadDiscussion"
                 v-for="(comment, i) in rdvsComment" :key="i" v-if="rdvsComment && rdvsComment.length && comment">
              <div class="vadDiscussion--bulle is-size-6" v-if="comment.note"
                   :class="{'is-margin-bottom-xxsmall has-bg-light':comment.report_note}">
                <div class="content" v-html="comment.note"></div>
              </div>
              <div class="vadDiscussion--bulle is-size-6" v-if="comment.report_note">
                <div class="content" v-html="comment.report_note"></div>
              </div>

              <div class="columns is-gapless is-size-6">
                <div class="column is-12">
                  <span v-if="comment.date">
                    <b>Date :</b> {{moment(comment.date).format('DD MMMM YYYY')}}
                  </span>
                  <span v-if="comment.seller_name">
                    <span v-if="comment.date" class="is-padding-left-xsmall is-padding-right-xsmall"> - </span>
                    <b>Auteur :</b> {{comment.seller_name}}
                  </span>
                  <span v-if="comment.title">
                    <span class="is-padding-left-xsmall is-padding-right-xsmall"> - </span>
                    <b>Origine : </b>
                    <router-link :to="{name: 'ContactRdv', params: {id: sourceContact.pk}}">
                     <a class="is-underline">{{comment.title}}</a>
                    </router-link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div><!-- END div pour scrollbar-->
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import { isEmpty } from 'lodash'

  export default {
    name: 'ContactInformations',
    mixins: [DefaultValues],
    data () {
      return {
        moment
      }
    },
    props: {
      sourceContact: {
        type: Object,
        required: true
      },
      sourceSpouse: {
        type: Object,
        required: false,
        default: null
      },
      sourceRdvs: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isExternal', 'currentUserPk']),
      c () {
        return this.sourceContact
      },
      spouse () {
        return this.sourceSpouse
      },
      isHuman () {
        return this.c.nature === 'human'
      },
      rdvsComment () {
        return this.sourceRdvs.map(x => {
          if (x.note || x.report_note) {
            return {
              title: `Rdv ${x.rdv_type} du ${moment(x.date).format('DD/MM/YYYY')}`,
              date: x.date,
              seller_name: x.seller_name,
              note: x.note,
              report_note: x.report_note
            }
          }
        }).filter(x => x)
      }
    },
    watch: {
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'CONTACT_SELECTION' && results.entities && results.entities.length) {
            this.$emit('updateSpouse', results.entities[0].pk)
          } else if (mode === 'NEW_CONTACT' && results.contact && !this.fromQuickview) {
            this.addSpouse(results.contact)
          } else if (mode === 'NEW_NOTE') {
            this.addComment(results)
          }
        }
      }
    },
    methods: {
      addComment (result) {
        console.log(result)
        let contact = {
          comment: result
        }
        this.$api.contactService.patch(this.c.pk, contact).then(r => {
          console.log(r)
          this.$notify({
            type: 'is-success',
            text: 'Le commentaire a été créé.'
          })
          this.$emit('reloadContact')
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du commentaire.'
          })
        })
      },
      openNewComment (edit) {
        let params
        if (edit) {
          params = {
            source: {
              note: this.c.comment
            }
          }
        }
        this.$store.commit('setQuickview', { mode: 'NEW_NOTE', params })
      },
      openRdv (date) {
        let day = moment(date).format('DD')
        let month = moment(date).format('MM')
        let year = moment(date).format('YYYY')
        this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
      },
      openNewContactQuickView () {
        if (isEmpty(this.c.address)) {
          return this.$notify({
            type: 'is-warning',
            text: 'L\'adresse du contact est requis pour créer son conjoint.'
          })
        }
        this.$store.commit('setQuickview', {
          mode: 'NEW_CONTACT',
          params: {
            showSellerSelect: false,
            address: this.c.address,
            isSpouse: true
          }
        })
      },
      openContactSelectionQuickView () {
        let contact = null
        if (this.c && this.c.pk) contact = this.c.pk
        let params = {
          excludes: [contact],
          mode: 'store',
          seller: this.currentUserPk
        }
        this.$store.commit('setQuickview', { mode: 'CONTACT_SELECTION', params })
      },
      addSpouse (contact) {
        contact.seller = this.currentUserPk
        this.$api.contactService.post(contact).then(r => {
          this.$emit('updateSpouse', r.data.pk)
          this.$notify({
            type: 'is-success',
            text: 'Le conjoint a été créé.'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du conjoint.'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactInformations.vue